import type { ActivityIngredient } from '@apps/main/modules/recipe/ingredients';

import type { IngredientId } from '@libs/trip-planner-interfaces';

import type { IngredientSerializer } from '..';

import { serializeActivity } from './serialize';
import { deserializeActivity } from './deserialize';

export const ActivitySerializer: IngredientSerializer<ActivityIngredient> = {
  serialize: (activity: ActivityIngredient): string =>
    serializeActivity(activity),
  deserialize: (
    value: string,
    parentIngredientId: IngredientId
  ): ActivityIngredient => deserializeActivity(value, parentIngredientId),
};

export { isSerializedActivity } from './helpers';
